import React, { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
const ImageSlider = ({sliderInfo={}, toggleModalFn}) => {
  const [currentIndex, setCurrentIndex] = useState(sliderInfo.startIndex);
  const handleDownload = (fileUrl) => {
    let urlParts = fileUrl.split('/');
    let fileName = urlParts[urlParts.length - 1].split('?')[0];
    let link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  
  const currentImageUrl = sliderInfo.images?.[currentIndex]?.original;
  return(
    <Dialog
      fullScreen
      open={sliderInfo.modal}

      onClose={toggleModalFn}
    >
      <DialogTitle id="scroll-dialog-title">
        {sliderInfo.title}
      </DialogTitle>
      <DialogContent dividers={true}>
        <ImageGallery
          startIndex={sliderInfo?.startIndex}
          items={sliderInfo.images}
          additionalClass="image-custom-preview"
          onSlide={(index) => setCurrentIndex(index)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleModalFn} variant='outlined' color="primary">Cancel</Button>
        <Button variant="contained" color="primary" onClick={() => handleDownload(currentImageUrl)}>Download</Button>
      </DialogActions>
    </Dialog>
  )
}
export default ImageSlider;
